'use client';

import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { SoundboardItem as SoundboardItemType } from '@/utils/soundboardStorage';
import SoundboardItem from './SoundboardItem';

interface SortableSoundboardItemProps {
  item: SoundboardItemType;
  onPlay: (item: SoundboardItemType) => void;
  isPlaying?: boolean;
}

const SortableSoundboardItem: React.FC<SortableSoundboardItemProps> = ({
  item,
  onPlay,
  isPlaying = false
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: item.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div ref={setNodeRef} style={style}>
      <SoundboardItem
        item={item}
        onPlay={onPlay}
        isPlaying={isPlaying}
        isDragging={isDragging}
        dragHandleProps={{ ...attributes, ...listeners }}
      />
    </div>
  );
};

export default SortableSoundboardItem;
